import { render, staticRenderFns } from "./AddLogNoteDialog.vue?vue&type=template&id=964ba6d0&scoped=true&lang=pug&"
import script from "./AddLogNoteDialog.vue?vue&type=script&lang=js&"
export * from "./AddLogNoteDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddLogNoteDialog.vue?vue&type=style&index=0&id=964ba6d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964ba6d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
